import Typography from '@mui/material/Typography';
import { useIntl } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';

export function TechnicalErrorPage() {
  const intl = useIntl();
  const location = useLocation();
  const { previousUrl } = location.state;

  return (
    <Layout>
      <Typography variant="h1">{intl.formatMessage({ id: 'error.technicalErrorOccured' })}</Typography>
      <Typography>
        {intl.formatMessage({ id: 'error.technicalErrorUrl' }) + ': '}
        <Link to={previousUrl}>{previousUrl}</Link>
      </Typography>
    </Layout>
  );
}
